import Header from '../../../components/header'
import Footer from '../../../components/footer'
import { useState } from "react";
import axios from "axios";
import style from './03_teachersregistration.css'
import img from '../../Images/Hero.png'

import step1 from '../../Images/account.png'
import step2 from '../../Images/search-person.png'
import step3 from '../../Images/phone-call.png'

import trust1 from '../../Images/honorable.png'
import trust2 from '../../Images/nearby.png'
import trust3 from '../../Images/10815875.png'
import trust4 from '../../Images/language.png'
import trust5 from '../../Images/phone-call_02.png'
import trust6 from '../../Images/free_02.png'
import PricingTeachers from '../../components/03_pricingteachers/03_pricingteachers';

export default function TeachersRegistration() {
  const [form, setForm] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    description: "",
    experience: "",
    services: [],
    headline: "",
    instruments: "",
    language: "",
    city: "",
    fees: "",
    gender: "",
    teaching_mode: [],
    profilePhoto: null,
  });

  const servicesList = [
    "Online Classes",
    "Offline Classes",
    "Home Tuition",
    "Exam Preparation",
    "Competition Coaching",
    "Performance Coaching",
    "Music Theory",
    "Beginner Lessons",
    "Advanced Lessons",
    "Children Classes"
    ];

    const handleServiceChange = (e) => {
    const { value, checked } = e.target;

    setForm((prev) => {
        let updated = [...prev.services];

        if (checked) {
        if (updated.length >= 5) {
            alert("You can select a maximum of 5 services.");
            return prev;
        }
        updated.push(value);
        } else {
        updated = updated.filter((item) => item !== value);
        }

        return {
        ...prev,
        services: updated,
        };
    });
};

    const handleChange = (e) => {
    const { name, value, multiple, options, files } = e.target;

    if (files) {
        setForm(prev => ({
            ...prev,
            [name]: files[0]
        }));
        return;
    }

    if (multiple) {
        const values = Array.from(options)
            .filter(option => option.selected)
            .map(option => option.value);

        setForm(prev => ({
            ...prev,
            [name]: values,
        }));
    } else {
        setForm(prev => ({
            ...prev,
            [name]: value,
        }));
    }
};

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();

    Object.entries(form).forEach(([key, value]) => {

        if (value === null) return;

        if (Array.isArray(value)) {
            value.forEach(item => {
                formData.append(`${key}[]`, item);
            });
        } else {
            formData.append(key, value);
        }

    });

      const res = await axios.post(
        "https://sursaathi.in/testcontacter.php",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      alert(res.data.message || "Registration Successful");

      // Reset form
      setForm({
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        description: "",
        experience: "",
        services: [],
        headline: "",
        instruments: "",
        language: "",
        fees: "",
        city: "",
        gender: "",
        teaching_mode: [],
      });
    } catch (err) {
      alert(
        err.response?.data?.error ||
          err.response?.data?.message ||
          "Something went wrong"
      );
    }
  };

    return (
        <div style={{ backgroundColor: '#FFFDF4' }}>
            <Header />
                <div className='TeachersRegistationPage-HeroSection'>
                    <div className='TeachersRegistationPage-HeroSection-Info'>
                        <h1>Get Discovered by Students Worldwide.</h1>
                        <p>
                            Whether you teach singing or musical instruments, online or in person, SurSaathi helps students find and connect with you—for free. You decide your own lesson fees, and students pay you directly.
                        </p>
                        <div className='TeachersRegistationPage-HeroSection-Keys'>
                            <span>Free Listing</span>
                            <span>Online, Offline & Hybrid Teaching</span>
                            <span>No Subscription Fees</span>
                            <span>Students Contact You Directly</span>
                        </div>
                        <a href="#teachersregistrationform">Create My Free Profile</a>
                        <span>No credit card. No commissions. No hidden charges.</span>
                    </div>
                    <img src={img} alt="" />
                </div >
                <PricingTeachers />
                <div id='teachersregistrationform'></div>
                <h2 className='TeachersRegistationPage-Form-title'>Create you Free Profile</h2>
                <form onSubmit={handleSubmit} className='TeachersRegistationPage-Form' >
                    <div>
                        <label>First Name</label>
                        <input
                        type="text"
                        name="firstname"
                        value={form.firstname}
                        onChange={handleChange}
                        required
                        />

                        <label>Last Name</label>
                        <input
                        type="text"
                        name="lastname"
                        value={form.lastname}
                        onChange={handleChange}
                        required
                        />

                        <label>Phone No</label>
                        <input
                        type="tel"
                        name="phone"
                        value={form.phone}
                        onChange={handleChange}
                        required
                        />

                        <label>Email</label>
                        <input
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        required
                        />
                        <label>Profile Photo</label>
                        <input
                            type="file"
                            name="profilePhoto"
                            accept="image/png,image/jpeg,image/jpg,image/webp"
                            onChange={handleChange}
                        />
                    </div>
                    <div>
                        <label>Your Description</label>
                        <textarea
                        name="description"
                        value={form.description}
                        onChange={handleChange}
                        maxLength={750}
                        />
                    </div>

                    <div>
                        <label>Your Experience</label>
                        <textarea
                        name="experience"
                        value={form.experience}
                        onChange={handleChange}
                        maxLength={450}
                        />
                    </div>

                    <label>Select Services (Max 5)</label>
                    <div className='TeachersRegistationPage-Form-Services'>
                        {servicesList.map((service) => (
                            <div key={service}>
                            <label>
                                <input
                                type="checkbox"
                                value={service}
                                checked={form.services.includes(service)}
                                onChange={handleServiceChange}
                                />
                                {service}
                            </label>
                            </div>
                        ))}

                        <p>{form.services.length}/5 selected</p>
                    </div>

                    <div>
                        <label>Headline for your Profile</label>
                        <input
                        type="text"
                        name="headline"
                        value={form.headline}
                        maxLength={50}
                        onChange={handleChange}
                        />

                        <label>Instruments</label>
                        <input
                        type="text"
                        name="instruments"
                        value={form.instruments}
                        onChange={handleChange}
                        required
                        />

                        <label>Language</label>
                        <input
                        type="text"
                        name="language"
                        value={form.language}
                        onChange={handleChange}
                        required
                        />

                        <label>Location (City)</label>
                        <input
                        type="text"
                        name="city"
                        value={form.city}
                        onChange={handleChange}
                        required
                        />

                        <label>Your hourly Fees</label>
                        <input
                        type="text"
                        name="fees"
                        value={form.fees}
                        onChange={handleChange}
                        required
                        />

                        <label>Gender</label>
                        <select
                        name="gender"
                        value={form.gender}
                        onChange={handleChange}
                        required
                        >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                        </select>

                        <label>Teaching Mode</label>

                        {["Online", "Offline", "Can Travel"].map((mode) => (
                        <label key={mode} style={{ display: "block" }}>
                            <input
                            type="checkbox"
                            value={mode}
                            checked={form.teaching_mode.includes(mode)}
                            
                            onChange={(e) => {
                                const { value, checked } = e.target;

                                setForm((prev) => ({
                                ...prev,
                                teaching_mode: checked
                                    ? [...prev.teaching_mode, value]
                                    : prev.teaching_mode.filter((item) => item !== value),
                                }));
                            }}
                            />
                            {mode}
                        </label>
                        ))}
                    </div>

                    <button type="submit">Register</button>
                </form>
                <div className='TeachersRegistationPage-StepsSection-Main'>
                    <h2>Get Started in 3 Simple Steps</h2>
                    <div className='TeachersRegistationPage-StepsSection-Main-Dash'></div>
                    <div className='TeachersRegistationPage-StepsSection-Flex'>
                        <div className='TeachersRegistationPage-StepsSection-Card'>
                            <span>Step 1</span>
                            <h3>Create Your Profile</h3>
                            <p>Add your teaching details in just a few minutes.</p>
                            <img src={step1} alt="" />
                        </div>
                        <div className='TeachersRegistationPage-StepsSection-Card'>
                            <span>Step 2</span>
                            <h3>Get Discovered</h3>
                            <p>Students search by instrument, location, language, and class mode.</p>
                            <img src={step2} alt="" />
                        </div>
                        <div className='TeachersRegistationPage-StepsSection-Card'>
                            <span>Step 3</span>
                            <h3>Start Receiving Enquiries</h3>
                            <p>Interested students contact you directly.</p>
                            <img src={step3} alt="" />
                        </div>
                    </div>
                </div>
                <div className='TeachersRegistationPage-ForSection-Main'>
                    <div className='TeachersRegistationPage-ForSection-Main-Card'>
                        <img src={trust1} alt="" />
                        <h3>Showcase Your Expertise</h3>
                        <p>
                            Display your instruments, genres, qualifications, experience, and teaching style.
                        </p>
                    </div>
                    <div className='TeachersRegistationPage-ForSection-Main-Card'>
                        <img src={trust2} alt="" />
                        <h3>Reach Students Near You</h3>
                        <p>
                            Appear in searches based on your city and teaching locations.
                        </p>
                    </div>
                    <div className='TeachersRegistationPage-ForSection-Main-Card'>
                        <img src={trust3} alt="" />
                        <h3>Teach Your Way</h3>
                        <p>
                            Offer online, offline, or hybrid classes.
                        </p>
                    </div>
                    <div className='TeachersRegistationPage-ForSection-Main-Card'>
                        <img src={trust4} alt="" />
                        <h3>Teach in Multiple Languages</h3>
                        <p>
                            Help students find teachers they can comfortably learn from.
                        </p>
                    </div>
                    <div className='TeachersRegistationPage-ForSection-Main-Card'>
                        <img src={trust5} alt="" />
                        <h3>Receive Direct Enquiries</h3>
                        <p>
                            Students contact you directly—no middlemen or commissions.
                        </p>
                    </div>
                    <div className='TeachersRegistationPage-ForSection-Main-Card'>
                        <img src={trust6} alt="" />
                        <h3>Forever Free</h3>
                        <p>
                            Listing your profile and receiving enquiries will always be free.
                        </p>
                    </div>
                </div>
            <Footer />
        </div>
    );
}
